import { render, staticRenderFns } from "./ExemptionBoard.vue?vue&type=template&id=5ee0d414&scoped=true&"
import script from "./ExemptionBoard.vue?vue&type=script&lang=js&"
export * from "./ExemptionBoard.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionBoard.vue?vue&type=style&index=0&id=5ee0d414&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee0d414",
  null
  
)

export default component.exports